import React from 'react';
import styled from 'styled-components';
import { BUTTON_OPTIONS } from '../../common/atoms/Button';
import KeywordSuggestions, {
  KEYWORD_SUGGESTIONS_OPTIONS,
} from '../KeywordSuggestions';
import SearchAreaSuggestions from '../SearchAreaSuggestions';
import UseMyLocationButton from '../../atoms/UseMyLocationButton';
import useSearchResultsLogic from '../SearchResults/useSearchResultsLogic';

const VERTICAL_SEARCH_RESULTS_CONSTS = {
  MAX_KEYWORD_SUGGESTION_TYPES: 2,
  SUGGESTION_TYPE_STYLES: {
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.CATEGORY_SUGGESTIONS]: {
      emphasis: true,
      heading: undefined,
      highlightMatch: false,
      hoverIcon: false,
    },
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.PROFILE_SUGGESTIONS]: {
      emphasis: false,
      heading: undefined,
      highlightMatch: false,
      hoverIcon: false,
    },
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.RECENT_SEARCHES]: {
      emphasis: false,
      heading: 'Recent Searches',
      highlightMatch: false,
      hoverIcon: false,
    },
    [KEYWORD_SUGGESTIONS_OPTIONS.IDS.POPULAR_SEARCHES]: {
      emphasis: false,
      heading: 'Popular Searches',
      highlightMatch: false,
      hoverIcon: false,
    },
  },
  USE_MY_LOCATION_BUTTON_SIZE: BUTTON_OPTIONS.SIZES.MD,
};

const StyledContainer = styled.div`
  padding: ${props => props.theme.padding.small} 0;
`;

const StyledUseMyLocationButton = styled(UseMyLocationButton)`
  margin-top: ${props => props.theme.margin.normal};
`;

const VerticalSearchResults = () => {
  const {
    showKeywordSuggestions,
    showSearchAreaSuggestions,
    showSuggestions,
  } = useSearchResultsLogic();

  if (!showSuggestions) return <></>;
  return (
    <StyledContainer>
      {showSearchAreaSuggestions && (
        <>
          <SearchAreaSuggestions />
          <StyledUseMyLocationButton
            size={VERTICAL_SEARCH_RESULTS_CONSTS.USE_MY_LOCATION_BUTTON_SIZE}
          />
        </>
      )}
      {showKeywordSuggestions && (
        <KeywordSuggestions
          maxSuggestionTypes={
            VERTICAL_SEARCH_RESULTS_CONSTS.MAX_KEYWORD_SUGGESTION_TYPES
          }
          suggestionTypeStyles={
            VERTICAL_SEARCH_RESULTS_CONSTS.SUGGESTION_TYPE_STYLES
          }
        />
      )}
    </StyledContainer>
  );
};

export default VerticalSearchResults;
